import React from 'react'
import { GlobalDataContext, useDebtStore } from '../../common'

export const useDebtsUiStore = () => {
  const context = React.useContext(GlobalDataContext)

  if (!context) {
    throw new Error('useDebtsUiStore() must be used within the GlobalDataContext')
  }

  return useDebtStore().uiStore
}
